/**
 * A row in the Contract Release CSV data (only the columns we care about)
 */
export interface ContractReleaseRow_PreProcessed {
  /** Location identifier */
  location: string;

  /** Purchase/Sale/Other indicator */
  pso: string;

  /** Contract type */
  cont: string;

  /** Contract number */
  contractNo: number;

  /** Status of the contract */
  status: string;

  /** Name of the entity */
  name: string;

  /** Commodity code */
  commodity: string;

  /** Description of the commodity */
  commodityDescription: string;

  /** Release number */
  rel: number;

  /** Unit of Measure */
  uom: string;

  /** Quantity value */
  quantity: number;

  /** Balance value */
  balance: number;

  /** Add/Deduct Rate Type */
  addDedRateType: string;

  /** First Add/Deduct Code */
  addDedCode1: string;

  /** First Add/Deduct Adjustment */
  addDedAdjustment1: string;

  /** First Add/Deduct Amount */
  addDedAmount1: number;

  /** Second Add/Deduct Code */
  addDedCode2: string | null;

  /** Second Add/Deduct Adjustment */
  addDedAdjustment2: string | null;

  /** Second Add/Deduct Amount */
  addDedAmount2: number;

  /** Third Add/Deduct Code */
  addDedCode3: string | null;

  /** Third Add/Deduct Adjustment */
  addDedAdjustment3: string | null;

  /** Third Add/Deduct Amount */
  addDedAmount3: number;

  /** Fourth Add/Deduct Code */
  addDedCode4: string | null;

  /** Fourth Add/Deduct Adjustment */
  addDedAdjustment4: string | null;

  /** Fourth Add/Deduct Amount */
  addDedAmount4: number;

  /** Fifth Add/Deduct Code */
  addDedCode5: string | null;

  /** Fifth Add/Deduct Adjustment */
  addDedAdjustment5: string | null;

  /** Fifth Add/Deduct Amount */
  addDedAmount5: number;
}

export interface ContractReleaseRow_Processed extends ContractReleaseRow_PreProcessed {
  /** OTC Fee Premium */
  otcFeePremium: number;
}

export type ContractRelease_ColumnMappings = ColumnMappings<ContractReleaseRow_PreProcessed>
export type ColumnMappings<T> = { [key in keyof T]: string }
export type ColumnMappingsSpec<T> = {
  [key in keyof T]: {
    validNames: string[],
    validColumns: string[],
  }
}

/**
 * Mapping of ContractReleaseRow_Processed keys to their corresponding column names and letters in the CSV
 */
export const ContractReleaseRow_Mappings: ColumnMappingsSpec<ContractReleaseRow_PreProcessed> = {
  location: {
    validNames: ["Location"],
    validColumns: ["A"]
  },
  pso: {
    validNames: ["P/S/O"],
    validColumns: ["B"]
  },
  cont: {
    validNames: ["Cont"],
    validColumns: ["C"]
  },
  contractNo: {
    validNames: ["Contract No"],
    validColumns: ["D"]
  },
  status: {
    validNames: ["Status"],
    validColumns: ["E"]
  },
  name: {
    validNames: ["Name"],
    validColumns: ["G"]
  },
  commodity: {
    validNames: ["Commodity"],
    validColumns: ["H"]
  },
  commodityDescription: {
    validNames: ["Commodity Description"],
    validColumns: ["I"]
  },
  rel: {
    validNames: ["Rel"],
    validColumns: ["S"]
  },
  uom: {
    validNames: ["UOM"],
    validColumns: ["U"]
  },
  quantity: {
    validNames: ["Quantity"],
    validColumns: ["V"]
  },
  balance: {
    validNames: ["Balance"],
    validColumns: ["W"]
  },
  addDedRateType: {
    validNames: ["Add/Ded Rate Type"],
    validColumns: ["AX"]
  },
  addDedCode1: {
    validNames: ["Add/Ded Code 1"],
    validColumns: ["AY"]
  },
  addDedAdjustment1: {
    validNames: ["Add/Ded Adjustment 1"],
    validColumns: ["AZ"]
  },
  addDedAmount1: {
    validNames: ["Add/Ded Amount 1"],
    validColumns: ["BA"]
  },
  addDedCode2: {
    validNames: ["Add/Ded Code 2"],
    validColumns: ["BB"]
  },
  addDedAdjustment2: {
    validNames: ["Add/Ded Adjustment 2"],
    validColumns: ["BC"]
  },
  addDedAmount2: {
    validNames: ["Add/Ded Amount 2"],
    validColumns: ["BD"]
  },
  addDedCode3: {
    validNames: ["Add/Ded Code 3"],
    validColumns: ["BE"]
  },
  addDedAdjustment3: {
    validNames: ["Add/Ded Adjustment 3"],
    validColumns: ["BF"]
  },
  addDedAmount3: {
    validNames: ["Add/Ded Amount 3"],
    validColumns: ["BG"]
  },
  addDedCode4: {
    validNames: ["Add/Ded Code 4"],
    validColumns: ["BH"]
  },
  addDedAdjustment4: {
    validNames: ["Add/Ded Adjustment 4"],
    validColumns: ["BI"]
  },
  addDedAmount4: {
    validNames: ["Add/Ded Amount 4"],
    validColumns: ["BJ"]
  },
  addDedCode5: {
    validNames: ["Add/Ded Code 5"],
    validColumns: ["BK"]
  },
  addDedAdjustment5: {
    validNames: ["Add/Ded Adjustment 5"],
    validColumns: ["BL"]
  },
  addDedAmount5: {
    validNames: ["Add/Ded Amount 5"],
    validColumns: ["BM"]
  },
};
